import { render, staticRenderFns } from "./CitasConfirmacion.vue?vue&type=template&id=1751afef"
import script from "./CitasConfirmacion.vue?vue&type=script&lang=js"
export * from "./CitasConfirmacion.vue?vue&type=script&lang=js"
import style0 from "./CitasConfirmacion.vue?vue&type=style&index=0&id=1751afef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports